import { FC } from 'react';

interface SummarySectionProps {
  title: string;
  count: number;
  children: React.ReactNode;
}

export const SummarySection: FC<SummarySectionProps> = ({ title, count, children }) => (
  <div className="my-6">
    <div className="flex items-baseline gap-3 mb-3">
      <h2 className="text-xl font-semibold text-gray-700">{title}</h2>
      <span className="inline-flex items-center justify-center min-w-6 h-6 px-1.5 rounded-full bg-gray-100 text-sm font-medium text-gray-600 leading-none">
        {count}
      </span>
    </div>
    <div className="flex flex-col gap-2">{children}</div>
  </div>
);
